var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isCityManager)?_c('create-invoice-tab',{attrs:{"globalSearch":_vm.globalSearch}}):_c('create-invoice-whole',{attrs:{"globalSearch":_vm.globalSearch}})}
var staticRenderFns = []

export { render, staticRenderFns }